import {
  FieldMatch,
  FieldTypes,
  SearchableField,
} from "src/flowGraph/canvasSearch/extractNodeFields";
import { SchemaOptions } from "src/router/SearchParams";
import { PropertyUI, SchemaUI } from "src/schema/schemaMappingUtils";

const stringifyProperty = (property: PropertyUI) => {
  const [propertyType] = property.type;

  if (propertyType === "object") {
    return [property.fieldName, ...Object.keys(property.properties ?? {})].join(
      ", ",
    );
  }

  if (propertyType === "enum") {
    return [
      property.fieldName,
      property.enum?.map((enumValue) => enumValue.value),
    ].join(", ");
  }

  return property.fieldName;
};

const extractSchemaFields = (
  schema: SchemaUI,
  schemaType: SchemaOptions,
): SearchableField[] => {
  return schema.properties.map((property) => ({
    id: `${property.fieldName}:${schemaType}`,
    value: stringifyProperty(property),
  }));
};

type FindMatchingSchemaFieldsParams = {
  schema: SchemaUI | undefined;
  searchTerm: string;
  schemaType: SchemaOptions;
  nodeId: string;
};

export const findMatchingSchemaFields = ({
  schema,
  searchTerm,
  schemaType,
  nodeId,
}: FindMatchingSchemaFieldsParams): FieldMatch[] => {
  if (!searchTerm || !schema) {
    return [];
  }

  const lowerSearchTerm = searchTerm.toLowerCase();
  const fields = extractSchemaFields(schema, schemaType);

  return fields
    .filter((field) =>
      (field.value ?? "").toLowerCase().includes(lowerSearchTerm),
    )
    .map((field) => ({
      nodeId,
      fieldId: field.id,
      fieldValue: field.value ?? "",
      fieldType:
        schemaType === SchemaOptions.Input
          ? FieldTypes.INPUT_SCHEMA
          : FieldTypes.OUTPUT_SCHEMA,
    }));
};
